import { render, staticRenderFns } from "./ComplaintManageNull.vue?vue&type=template&id=34cd2d93&"
import script from "./ComplaintManageNull.vue?vue&type=script&lang=js&"
export * from "./ComplaintManageNull.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintManageNull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports